export function toSite(site) {
    return {
        id: site.id,
        environmentId: site.environmentId,
        key: site.key,
        siteId: site.siteId,
        studyId: site.studyId,
        name: site.metadata.name,
        number: site.metadata.number,
        countryCode: site.metadata.address.countryCode,
        siteLocales: site.metadata.siteLocales,
        participantLocales: site.metadata.participantLocales,
    };
}
export function toEnvironment(environment) {
    return {
        id: environment.id,
        name: environment.name,
        isProd: environment.deployment.isProd,
    };
}
